import React from "react";
import { useTranslation } from "react-i18next";
import { useInterviewContext } from "../InterviewContext";

const RemoteWork = () => {
  const { t } = useTranslation();
  const { remoteWorkOptions, interview, setInterview } = useInterviewContext();

  const onChangeRemoteWork = (e) => {
    setInterview((prevInterview) => ({
      ...prevInterview,
      availabilityAndConditions: {
        ...prevInterview.availabilityAndConditions,
        remoteWorkId: prevInterview.availabilityAndConditions.remoteWorkId.includes(
          Number(e.target.value)
        )
          ? prevInterview.availabilityAndConditions.remoteWorkId.filter(
              (option) => option !== Number(e.target.value)
            )
          : [
              ...prevInterview.availabilityAndConditions.remoteWorkId,
              Number(e.target.value)
            ]
      }
    }));
  };

  return (
    <form className="remote-work">
      <h1>{t("Remote Work")}</h1>
      {remoteWorkOptions.map((item, index) => (
        <div className="form-check form-check-inline" key={index}>
          <input
            className="form-check-input"
            type="checkbox"
            onChange={onChangeRemoteWork}
            name="remoteWorkId"
            value={item.id}
            checked={interview.availabilityAndConditions.remoteWorkId.includes(
              item.id
            )}
          />
          <label htmlFor="remoteWorkId">{t(item.description)}</label>
        </div>
      ))}
    </form>
  );
};

export default RemoteWork;
